import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { SIDEBAR_WIDTH } from '../../utils/constants';
import { IS_MOCK_MODE } from '../../services/mockData';

export default function CollegeLayout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <TopBar onMenuClick={() => setMobileOpen(true)} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ml: isMobile ? 0 : `${SIDEBAR_WIDTH}px`,
          width: isMobile ? '100%' : `calc(100% - ${SIDEBAR_WIDTH}px)`,
          minWidth: 0,
          overflowX: 'hidden',
          backgroundColor: 'background.default',
          minHeight: '100vh',
        }}
      >
        <Toolbar />
        {IS_MOCK_MODE && (
          <Box sx={{
            backgroundColor: '#fef3c7',
            borderBottom: '1px solid #fcd34d',
            px: { xs: 2, sm: 3 },
            py: 1,
          }}>
            <Typography variant="caption" sx={{ color: '#92400e', fontWeight: 600 }}>
              DEMO MODE — Showing mock data. No live backend or Cognito session is connected.
            </Typography>
          </Box>
        )}
        <Box sx={{ p: { xs: 2, sm: 3 } }}>{children}</Box>
      </Box>
    </Box>
  );
}
